// Пагинация и базовые примитивы, общие для всех ручек.
import { z } from 'zod'

// Идентификатор сущности (cuid/uuid — конкретный формат решает бэкенд, контракт не сужает).
export const idSchema = z.string().min(1)

// Дата без времени, ISO 8601 (YYYY-MM-DD). Даты в API — всегда строки, не z.date().
export const isoDateSchema = z.iso.date()

// Дата-время, ISO 8601 с таймзоной.
export const isoDateTimeSchema = z.iso.datetime({ offset: true })

// Время суток HH:MM (для forecast_time).
export const timeOfDaySchema = z.iso.time({ precision: -1 })

// Месяц в формате YYYY-MM (для GET /moods/month).
export const yearMonthSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'ожидается YYYY-MM')

// Курсорная пагинация запроса.
export const paginationQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
})
export type PaginationQuery = z.infer<typeof paginationQuerySchema>

// Обёртка постраничного ответа: элементы + курсор следующей страницы (null — страниц больше нет).
export const paginated = <ItemSchema extends z.ZodTypeAny>(itemSchema: ItemSchema) =>
  z.object({
    items: z.array(itemSchema),
    next_cursor: z.string().nullable(),
  })

// Плоский успешный ответ для операций без содержательного тела (revoke, delete, read).
export const okResponseSchema = z.object({ ok: z.literal(true) })
export type OkResponse = z.infer<typeof okResponseSchema>
